function compareValues(left, right) {
  const leftIsEmpty = left === null || left === undefined || left === "";
  const rightIsEmpty = right === null || right === undefined || right === "";

  if (leftIsEmpty && rightIsEmpty) {
    return 0;
  }

  if (leftIsEmpty) {
    return 1;
  }

  if (rightIsEmpty) {
    return -1;
  }

  if (typeof left === "number" && typeof right === "number") {
    return left - right;
  }

  return String(left).localeCompare(String(right), undefined, {
    numeric: true,
    sensitivity: "base"
  });
}

function compareCreatedAt(left, right) {
  return String(left ?? "").localeCompare(String(right ?? ""));
}

export function sortRows(rows, columns, sortState) {
  if (!sortState?.key || !sortState?.direction) {
    return rows;
  }

  const column = columns.find((entry) => entry.key === sortState.key);
  if (!column) {
    return rows;
  }

  const direction = sortState.direction === "desc" ? -1 : 1;
  const getSortValue = column.sortValue ?? ((row) => row[column.key]);

  return rows
    .map((row, index) => ({ row, index }))
    .sort((left, right) => {
      const comparison = compareValues(getSortValue(left.row), getSortValue(right.row));
      if (comparison !== 0) {
        return comparison * direction;
      }

      const createdAtComparison = compareCreatedAt(left.row?.createdAt, right.row?.createdAt);
      if (createdAtComparison !== 0) {
        return createdAtComparison * direction;
      }

      return left.index - right.index;
    })
    .map((entry) => entry.row);
}
